import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWallDown"><Path d="M16.75 12.75L12 17.5L7.25 12.75" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2.5V16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 21.5H4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWallDown;
